import Plyr from 'plyr';
import Flickity from 'flickity';
import { offset } from './lib/utils.js';
import gsap from 'gsap';
import Draggable from 'gsap/Draggable.js';
import MotionPathPlugin from 'gsap/MotionPathPlugin.js';
import { createGLightbox } from './lib/glightbox';

gsap.registerPlugin(Draggable, MotionPathPlugin);

const ff_altaX: LegacyModule = {
	heroTriggered: false,
	heroThreshold: 100,

	ctaTriggered: false,

	currentTestingVideoIndex: 0,
	testingVideos: [],
	performanceWeight: 5,

	payloads: {
		0: {
			ratio: '3.5',
			flightTime: '50',
		},
		5: {
			ratio: '3.1',
			flightTime: '41.7',
		},
		10: {
			ratio: '2.8',
			flightTime: '33.3',
		},
		15: {
			ratio: '2.6',
			flightTime: '26.6',
		},
		20: {
			ratio: '2.4',
			flightTime: '22',
		},
		25: {
			ratio: '2.2',
			flightTime: '18',
		},
		30: {
			ratio: '2.0',
			flightTime: '12.5',
		},
		35: {
			ratio: '1.9',
			flightTime: '10.75',
		},
	},

	imagePath: 'https://freeflysystems.com/wp-content/themes/freefly/dist/images/alta-x',

	flopdapter: {
		playing: false,
		directory: 'flopdapter',
		start: 0,
		current: 0,
		height: 625,
		width: 1000,
		count: 97,
		frames: [],
		version: '0.0.1',
	},
	boom: {
		directory: 'boom',
		start: 0,
		current: 0,
		height: 563,
		width: 900,
		count: 116,
		frames: [],
		version: '0.0.1',
	},

	init: function () {
		this.cache();
		this.events();
		this.relativeVariables();
		this.updatePerformanceDisplay();
		this.initTestingPlayer();

		this.initFlopdapterAnimation();
		//this.initFlopdapterPlayer();

		this.initFootprintUI();
		this.initFootprintAnimation();
		this.initQuotes();
		this.initModels();
	},

	cache: function () {
		this.$hero = document.querySelector('.altaXHero');
		this.$buildCta = document.querySelector('.altaXBuildCta');
		this.$signoff = document.querySelector('.altaXSignoff');

		this.$performance = document.querySelector('.altaXPerformance');
		this.$performanceUp = document.querySelector('.altaXPerformance .up');
		this.$performanceDown = document.querySelector('.altaXPerformance .down');
		this.$performanceFlightTime = document.querySelector('.altaXPerformance .flightTime .number');
		this.$performanceThrustRatio = document.querySelector('.altaXPerformance .thrustRatio .number');
		this.$performanceWeight = document.querySelector('.altaXPerformance .weight .number');
		this.$performanceWeights = document.querySelectorAll('.altaXPerformance .graphicWeight');

		this.$flopdapter = document.querySelector('.altaXFlopdapter');
		this.$ecosystem = document.querySelector('.altaXEcosystem');

		this.$quotes = document.querySelector('.altaXQuote .rotator');
		this.$quotePrev = document.querySelector('.altaXQuote .prev');
		this.$quoteNext = document.querySelector('.altaXQuote .next');
	},

	events: function () {
		if (this.$performance) {
			this.$performanceUp.addEventListener('click', this.performanceUpClick.bind(this));
			this.$performanceDown.addEventListener('click', this.performanceDownClick.bind(this));
			createGLightbox({ selector: '.altaXPerformance .js-payloadChart' });
		}

		if (this.$ecosystem) document.addEventListener('optimizedScroll', this.scrollEvents.bind(this));

		if (this.$quotePrev) this.$quotePrev.addEventListener('click', this.quotePrevClick.bind(this));
		if (this.$quoteNext) this.$quoteNext.addEventListener('click', this.quoteNextClick.bind(this));
	},

	scrollEvents: function () {
		var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

		this.heroScroll(scrollPosition);
		this.ctaScroll(scrollPosition);
		this.ecosystemScroll(scrollPosition);
	},

	heroScroll: function (scrollPosition) {
		if (scrollPosition > this.heroThreshold && !this.heroTriggered) {
			this.$hero.classList.add('scrolled');
			this.heroTriggered = true;
		} else if (scrollPosition < this.heroThreshold && this.heroTriggered) {
			this.$hero.classList.remove('scrolled');
			this.heroTriggered = false;
		}
	},

	ctaScroll: function (scrollPosition) {
		if (
			scrollPosition > this.ctaThresholdTop &&
			scrollPosition < this.ctaThresholdBottom &&
			!this.ctaTriggered
		) {
			this.$buildCta.classList.add('active');
			this.ctaTriggered = true;
		} else if (
			(scrollPosition < this.ctaThresholdTop || scrollPosition > this.ctaThresholdBottom) &&
			this.ctaTriggered
		) {
			this.$buildCta.classList.remove('active');
			this.ctaTriggered = false;
		}
	},

	relativeVariables: function () {
		if (this.$ecosystem) {
			var ecosystemOffset = offset(this.$ecosystem);
			this.ecosystemThreshold = ecosystemOffset.top - Math.floor(0.25 * window.innerHeight);
		}
		if (this.$flopdapter) {
			var flopdapterOffset = offset(this.$flopdapter);
			this.flopdapterUpper = flopdapterOffset.top - Math.floor(1.25 * window.innerHeight);
			this.flopdapterLower = flopdapterOffset.top + this.$flopdapter.clientHeight;
		}

		if (this.$signoff) {
			var signoffOffset = offset(this.$signoff);
			this.ctaThresholdTop = window.innerHeight * 0.5;
			this.ctaThresholdBottom = signoffOffset.top - Math.floor(1.2 * window.innerHeight);
		}
	},

	updateGraphicWeights: function () {
		var activeCount = this.performanceWeight / 5 - 1;
		for (var i = 0; i < this.$performanceWeights.length; i++) {
			if (i < activeCount) {
				this.$performanceWeights[i].classList.add('active');
			} else {
				this.$performanceWeights[i].classList.remove('active');
			}
		}
	},

	performanceDownClick: function (e) {
		e.preventDefault();
		this.performanceWeight -= 5;
		this.performanceWeight = Math.max(this.performanceWeight, 0);
		this.updatePerformanceDisplay();
	},

	performanceUpClick: function (e) {
		e.preventDefault();
		this.performanceWeight += 5;
		this.performanceWeight = Math.min(this.performanceWeight, 35);
		this.updatePerformanceDisplay();
	},

	updatePerformanceDisplay: function () {
		if (!this.$performance) return;
		this.$performanceFlightTime.innerHTML = this.payloads[this.performanceWeight].flightTime;
		this.$performanceWeight.innerHTML = this.performanceWeight;
		this.$performanceThrustRatio.innerHTML = this.payloads[this.performanceWeight].ratio + ' : 1';
		this.updateGraphicWeights();
	},

	initTestingPlayer: function () {
		this.testingPlayer = new Plyr('.altaXTesting .player', {
			controls: ['play', 'progress', 'current-time', 'fullscreen'],
			tooltips: { controls: false, seek: false },
			invertTime: false,
			ratio: '16:9',
			//poster: altaProPerformancePoster,
		});
		//this.testingPlayer.on('ended', this.testingVideoEnded.bind(this) );
	},

	//Canvas utilites
	preloadImages: function (animationObj, loadCallback) {
		for (var i = animationObj.start; i < animationObj.count; i++) {
			var filename = ('00' + i).slice(-3) + '.png?v=' + animationObj.version;
			var img = new Image();
			img.src = this.imagePath + '/' + animationObj.directory + '/' + filename;
			//save reference to image
			animationObj.frames[i] = img;

			//Load first image into canvas
			if (loadCallback && i === animationObj.start) {
				img.addEventListener('load', loadCallback.bind(this, i));
			}
		}
	},

	loadFrameAt: function (animationObj, i) {
		var frame = animationObj.frames[i];
		if (!frame || !frame.complete || frame.naturalWidth === 0) return;
		animationObj.$canvas2d.clearRect(0, 0, animationObj.width, animationObj.height);
		animationObj.$canvas2d.drawImage(frame, 0, 0, animationObj.width, animationObj.height);
	},

	//Flopdapter Canvas
	initFlopdapterAnimation: function () {
		var self = this;
		var $canvas = document.querySelector('.altaXFlopdapter .canvas');
		if (!$canvas) return;

		document.addEventListener('optimizedScroll', this.flopdapterScroll.bind(this));

		this.flopdapter.$canvas2d = ($canvas as HTMLCanvasElement).getContext('2d');
		this.preloadImages(this.flopdapter, function (i) {
			self.loadFrameAt(self.flopdapter, i);
		});
	},

	flopdapterScroll: function () {
		var self = this;
		var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
		if (
			scrollPosition > this.flopdapterUpper &&
			scrollPosition < this.flopdapterLower &&
			!this.flopdapter.playing
		) {
			this.flopdapter.playing = true;
			requestAnimationFrame(self.flopdapterAdvance.bind(self));
		} else if (
			(scrollPosition < this.flopdapterUpper || scrollPosition > this.flopdapterLower) &&
			this.flopdapter.playing
		) {
			this.flopdapter.playing = false;
		}
	},

	flopdapterAdvance: function () {
		if (!this.flopdapter.playing) return;
		this.flopdapter.current++;
		if (this.flopdapter.current >= this.flopdapter.count) this.flopdapter.current = 0;
		this.loadFrameAt(this.flopdapter, this.flopdapter.current);
		requestAnimationFrame(this.flopdapterAdvance.bind(this));
	},

	//Flopdapter Video Player
	// initFlopdapterPlayer: function(){
	// 	this.$flopdapter = document.querySelector('.altaXFlopdapter');
	// 	if( !this.$flopdapter ) return;
	// 	this.$flopdapterPlayerWrapper = document.querySelector('.altaXFlopdapter .playerWrapper');
	// 	this.$flopdapterButton = document.querySelector('.altaXFlopdapter .button');

	// 	this.$flopdapterButton.addEventListener('click', this.flopdapterButtonClick.bind(this));

	// 	this.flopdapterPlayer = new Plyr('.altaXFlopdapter .player', {
	// 		controls: [], //'play', 'progress', 'current-time'
	// 		tooltips: { controls: false, seek: false },
	// 		invertTime: false,
	// 		ratio: '21:9',
	// 		//poster: altaProPerformancePoster,
	// 	});
	// 	this.flopdapterPlayer.on('play', this.flopdapterPlay.bind(this));
	// 	this.flopdapterPlayer.on('pause', this.flopdapterPause.bind(this));
	// },

	// flopdapterPlay: function(){
	// 	this.flopdapterPlaying = true;
	// 	this.updateFlopdapterPlayerDisplay();
	// },

	// flopdapterPause: function(){
	// 	this.flopdapterPlaying = false;
	// 	this.updateFlopdapterPlayerDisplay();
	// },

	// flopdapterButtonClick: function(){
	// 	if( this.flopdapterPlaying ){
	// 		this.flopdapterPlayer.pause()
	// 	}else{
	// 		this.flopdapterPlayer.play()
	// 	}
	// },

	// updateFlopdapterPlayerDisplay: function(){
	// 	if( this.flopdapterPlaying ){
	// 		this.$flopdapterButton.innerHTML = 'Pause';
	// 		this.$flopdapterPlayerWrapper.classList.add('playing');
	// 	}else{
	// 		this.$flopdapterButton.innerHTML = 'Play';
	// 		this.$flopdapterPlayerWrapper.classList.remove('playing');
	// 	}
	// },

	ecosystemScroll: function (scrollPosition) {
		if (scrollPosition > this.ecosystemThreshold && !this.ecosystemTriggered) {
			this.$ecosystem.classList.add('active');
			this.ecosystemTriggered = true;
		} else if (scrollPosition < this.ecosystemThreshold && this.ecosystemTriggered) {
			this.$ecosystem.classList.remove('active');
			this.ecosystemTriggered = false;
		}
	},

	initFootprintUI: function () {
		var self = this;
		this.$footprintUI = document.querySelector('#footprintDragUI');
		if (!this.$footprintUI) return;
		this.$footprintPath2 = this.$footprintUI.querySelector('.path2');
		this.$footprintHandle = this.$footprintUI.querySelector('.handle');
		this.$footprintProxy = this.$footprintUI.querySelector('.proxy');

		var bezierValues = [
			{ x: 25, y: 284 },
			{ x: 75, y: 206 },
			{ x: 75, y: 128 },
			{ x: 25, y: 50 },
		];

		var bounds = {
			minY: bezierValues[3].y,
			maxY: bezierValues[0].y,
		};

		var boundsDelta = Math.abs(bounds.maxY - bounds.minY);

		gsap.set([this.$footprintHandle, this.$footprintProxy], {
			transformOrigin: 'center',
			x: bezierValues[0].x,
			y: bezierValues[0].y,
		});

		var bezierTween = gsap.to(this.$footprintHandle, {
			motionPath: {
				path: bezierValues,
				type: 'cubic',
				// timeResolution: 0,
				autoRotate: true,
			},
			ease: 'none',
			paused: true,
			duration: 1,
		});

		gsap.set(this.$footprintPath2, { strokeDashoffset: -250 });

		var dashTween = gsap.to(this.$footprintPath2, {
			strokeDashoffset: 0,
			ease: 'none',
			paused: true,
			duration: 1,
		});

		var _draggable = new Draggable(this.$footprintProxy, {
			bounds: bounds,
			cursor: 'grab',
			onDrag: function () {
				var progress = (this.maxY - this.y) / boundsDelta;
				bezierTween.progress(progress);
				dashTween.progress(progress);
				var frameIndex = Math.floor(progress * (self.boom.count - 1));
				requestAnimationFrame(self.loadFrameAt.bind(self, self.boom, frameIndex));
			},
			trigger: this.$footprintHandle,
			overshootTolerance: 0,
		});
	},

	initFootprintAnimation: function () {
		var self = this;
		var $canvas = document.querySelector('.altaXFootprint .canvas');
		if (!$canvas) return;
		this.boom.$canvas2d = ($canvas as HTMLCanvasElement).getContext('2d');
		this.preloadImages(this.boom, function (i) {
			self.loadFrameAt(self.boom, i);
		});
	},

	initQuotes: function () {
		this.quoteRotator = new Flickity(this.$quotes, {
			contain: true,
			imagesLoaded: true,
			wrapAround: true,
			prevNextButtons: false,
		});
	},

	quotePrevClick: function (e) {
		e.preventDefault();
		this.quoteRotator.previous();
	},

	quoteNextClick: function (e) {
		e.preventDefault();
		this.quoteRotator.next();
	},

	initModels: function () {
		var viewPortWidth = 700;
		var viewPortHeight = 700;
		var backgroundColor = ' #eff5ff';
		var uWrap = true;
		var vWrap = false;
		var uMouseSensitivity = -0.0666667;
		var vMouseSensitivity = 0.1;
		var minZoom = 1;
		var maxZoom = 1;
		var rotationDamping = 0.96;
		var downScaleToBrowser = true;
		var addDownScaleGUIButton = false;
		var downloadOnInteraction = false;
		var imageExtension = 'jpg';
		var showLoading = false;
		var loadingIcon = false;
		var allowFullscreen = false; // Double-click in desktop browsers for fullscreen.
		var uReverse = false;
		var vReverse = false;
		var hotspots = {};

		var nameOfDiv = 'altaXCaseModelXR';
		var folderName = '/wp-content/themes/freefly/dist/images/alta-x/case-model-2';
		var uCount = 18;
		var vCount = 18;
		var uStartIndex = 9;
		var vStartIndex = 3;

		var _caseModel = new keyshotXR(
			nameOfDiv,
			folderName,
			viewPortWidth,
			viewPortHeight,
			backgroundColor,
			uCount,
			vCount,
			uWrap,
			vWrap,
			uMouseSensitivity,
			vMouseSensitivity,
			uStartIndex,
			vStartIndex,
			minZoom,
			maxZoom,
			rotationDamping,
			downScaleToBrowser,
			addDownScaleGUIButton,
			downloadOnInteraction,
			imageExtension,
			showLoading,
			loadingIcon,
			allowFullscreen,
			uReverse,
			vReverse,
			hotspots
		);

		nameOfDiv = 'altaXDroneModelXR';
		folderName = '/wp-content/themes/freefly/dist/images/alta-x/drone-model-2';
		uCount = 24;
		vCount = 18;
		uStartIndex = 12;
		vStartIndex = 9;

		var _droneModel = new keyshotXR(
			nameOfDiv,
			folderName,
			viewPortWidth,
			viewPortHeight,
			backgroundColor,
			uCount,
			vCount,
			uWrap,
			vWrap,
			uMouseSensitivity,
			vMouseSensitivity,
			uStartIndex,
			vStartIndex,
			minZoom,
			maxZoom,
			rotationDamping,
			downScaleToBrowser,
			addDownScaleGUIButton,
			downloadOnInteraction,
			imageExtension,
			showLoading,
			loadingIcon,
			allowFullscreen,
			uReverse,
			vReverse,
			hotspots
		);

		var $models = document.querySelectorAll('.altaXModels .model');
		for (var i = 0; i < $models.length; i++) {
			$models[i].addEventListener('mousedown', function (e) {
				(e.currentTarget as HTMLElement).classList.add('interacted');
			});
			$models[i].addEventListener('touchstart', function (e) {
				(e.currentTarget as HTMLElement).classList.add('interacted');
			});
		}
	},
};

ff_altaX.init();
